import axios from 'axios';

const api = axios.create({
  baseURL: 'https://casem.com.br',
  validateStatus: () => true,
});

export default api;
